import { Socket } from './socket-io.service';
import { SocketIoConfig } from './socket-io.config';

export function SocketFactory(
  config: SocketIoConfig,
) {
  return new Socket(config);
}
